import React from 'react';

import FEATURE_FLAGS, { useSafeFlag } from '../../utils/flags';
import {
  bulkEditLanguageValuesForCampaignLines,
  bulkEditPartialLPUrlForCampaignLines,
  changeCampaignLines,
} from '../actions';
import { connectEditor } from '../connect-editor';
import { languagesOptions, supportedLanguages } from '../constants';
import { isSelectable, isSelected } from '../utils';
import CampaignLinesBulkEditor from './CampaignLinesBulkEditor';

const getId = line => line.id;

const mapStateToProps = ({ campaignLinesById }, { isDraftCampaignEnabled }) => {
  const selectedCampaignLines = Object.values(campaignLinesById)
    .filter(line => isSelectable(line, isDraftCampaignEnabled))
    .filter(isSelected);
  const availableLanguages = new Set();
  selectedCampaignLines.forEach(line => {
    supportedLanguages.forEach(key => {
      if (line[key]) availableLanguages.add(line[key]);
    });
  });
  return {
    selectedCampaignLines,
    disabled: selectedCampaignLines.length < 1,
    availableLanguages: languagesOptions.filter(x =>
      Array.from(availableLanguages).includes(x.value),
    ),
  };
};

const mapDispatchToProps = {
  changeCampaignLines,
  bulkEditLanguageValuesForCampaignLines,
  bulkEditPartialLPUrlForCampaignLines,
};

const mergeProps = (
  { selectedCampaignLines, ...restStateProps },
  dispatchProps,
  ownProps,
) => ({
  ...ownProps,
  ...restStateProps,
  campaignLines: selectedCampaignLines,
  onChange: (name, value) =>
    dispatchProps.changeCampaignLines(
      selectedCampaignLines.map(getId),
      name,
      value,
    ),
  onChangeTargeting: (name, value) => {
    const campaignLinesSupportingTargeting = selectedCampaignLines.filter(
      campaignline => campaignline.product.supportsTargeting,
    );
    return dispatchProps.changeCampaignLines(
      campaignLinesSupportingTargeting.map(getId),
      name,
      value,
    );
  },
  onTextAssetChange: (languages, name, value) =>
    dispatchProps.bulkEditLanguageValuesForCampaignLines(
      selectedCampaignLines.map(getId),
      languages,
      name,
      value,
    ),
  onPartialLPChange: (languages, name, value) =>
    dispatchProps.bulkEditPartialLPUrlForCampaignLines(
      selectedCampaignLines.map(getId),
      languages,
      name,
      value,
    ),
});

// export for testing purposes
export const ConnectedCampaignLinesBulkEditor = connectEditor(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(CampaignLinesBulkEditor);

export default function CampaignLinesBulkEditorWrapper(props) {
  const isDraftCampaignEnabled = useSafeFlag(FEATURE_FLAGS.DRAFT_CAMPAIGN);
  return (
    <ConnectedCampaignLinesBulkEditor
      {...props}
      isDraftCampaignEnabled={isDraftCampaignEnabled}
    />
  );
}
